import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import ThreeView from "../components/three_view/three_view";
import { selectDefaultReducer } from "../redux/default/selectors";

const ThreeViewContainer = () => {
  const dispatch = useDispatch();

  const { 
    filters, 
    blockingUI, 
    translations,
    products 
  } = useSelector(selectDefaultReducer);

  if (!products?.length || products[0]?.objectDownloadUrlPriority === null || products[0]?.objectDownloadUrlPriority === undefined) {
    console.log("products or its options are missing.");
    return null;
  }
  const productsSortedByDownloadPriority = [...products].sort((a, b) => Number(a?.objectDownloadUrlPriority) - Number(b?.objectDownloadUrlPriority));

  const onMinInputChange = (key, value) => {
    dispatch(Action.minInputChanged({ key, value }));
    dispatch(Action.fetchFilterState());
  };

  const onMaxInputChange = (key, value) => {
    dispatch(Action.maxInputChanged({ key, value }));
    dispatch(Action.fetchFilterState());
  };

  const onSelectChange = (key, selectedOptions) => {
    const values = selectedOptions.map(option => option.value);
    dispatch(Action.selectFilterChanged({ key, values }));
    dispatch(Action.fetchFilterState());
  };

  const onResetFiltersClick = () => {
    dispatch(Action.resetFilters());
    dispatch(Action.fetchFilterState());
  };

  return (
    <ThreeView
      filters={filters}
      sortedProducts={productsSortedByDownloadPriority}
      blockingUI={blockingUI}
      translations={translations}
      onMinInputChange={onMinInputChange}
      onMaxInputChange={onMaxInputChange}
      onSelectChange={onSelectChange}
      onResetFiltersClick={onResetFiltersClick}
    />
  );
};

export default ThreeViewContainer;